import React from 'react';

type DataProviderContext = Record<string, any>;

export const DataContext = React.createContext<DataProviderContext>({});

export const useDataContext = () => React.useContext(DataContext);

export const DataProvider: React.FC = ({ children }) => {
    const [state, setState] = React.useState<DataProviderContext>({});
    const value = React.useMemo(
        () => ({
            state,
            setState: (url: string, updater: (currentState: unknown) => any) =>
                setState(currentState => ({
                    ...currentState,
                    [url]: updater(currentState[url]),
                })),
        }),
        [state]
    );

    return <DataContext.Provider value={value}>{children}</DataContext.Provider>;
};
